import { render, staticRenderFns } from "./customerStoreSelect.vue?vue&type=template&id=08b95ad9&scoped=true&"
import script from "./customerStoreSelect.vue?vue&type=script&lang=js&"
export * from "./customerStoreSelect.vue?vue&type=script&lang=js&"
import style0 from "./customerStoreSelect.vue?vue&type=style&index=0&id=08b95ad9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b95ad9",
  null
  
)

export default component.exports